import React from "react";

const CGU = () => (
  <div>
    <h2>Conditions Générales d'Utilisation</h2>

    <h5>
      For more information, please refer to our website:
      <a href="https://www.made4pitch.com" target="_blank" rel="noopener noreferrer">https://www.made4pitch.com</a>
    </h5>

    <h3>Préambule</h3>
    <p>
      La société par actions simplifiée Thomas Perron Co, au capital de 500
      euros, immatriculée au RCS de Bayonne sous le numéro 828 995 589, dont le
      siège social est 1247 Avenue de Bayonne 64210 Bidart, représentée par
      Monsieur Thomas Perron en sa qualité de Président (ci-après « l’Editeur
      »), édite un site d’enregistrement et de mise en ligne de vidéos
      consultable et accessible à l’adresse https://www.Speeker.net (ci-après
      pris ensemble « la plateforme Speeker »).
    </p>
    <p>
      La plateforme Speeker a pour objet de faciliter la mise en relation entre
      des personnes disposant de connaissances précises sur un sujet particulier
      et qui souhaiteraient transmettre ces connaissances à toutes personnes
      intéressées. La plateforme Speeker met ainsi en relation tout type de
      public entre eux. La plateforme Speeker leur permet de s’exprimer pendant
      un temps limité et de créer une vidéo. Speeker propose aux autres inscrits
      de visionner cette vidéo en échange d’une évaluation.
    </p>
    <p>
      Les présentes conditions générales ont pour objet de présenter les
      conditions dans lesquelles l’Editeur met à disposition la plateforme
      Speeker.
    </p>

    <h3>Définitions</h3>
    <p>
      Les termes ci-dessous définis auront entre les parties la signification
      suivante : « Speekerien.ne» désigne toute personne physique qui laisse sur
      la plateforme une vidéo non anonyme et/ou un commentaire, anonyme ou pas ;
      « Utilisateurs » : désigne les Speekeriens.
    </p>

    <h3>Acceptation des conditions d'utilisation</h3>
    <p>
      Les présentes conditions générales d’utilisation sont opposables à
      l’Utilisateur dès leur acceptation par ce dernier lors de l’inscription à
      la plateforme Speeker. L’acceptation des présentes conditions générales
      est mise en œuvre par le mécanisme du double-clic positif et constitue la
      preuve que l’Utilisateur a lu et a pris connaissance desdites
      stipulations.
    </p>
    <p>
      Dans tous les cas, la date de la première utilisation de la plateforme
      Speeker par l’Utilisateur vaut acceptation sans réserve des présentes
      conditions générales.
    </p>
    <p>
      L’Editeur se réserve le droit d’apporter aux présentes conditions
      générales toutes les modifications qu’il jugera nécessaires et utiles. Les
      présentes conditions générales sont applicables pendant toute la durée
      d’utilisation de la plateforme Speeker et jusqu’à ce que de nouvelles
      conditions générales remplacent les présentes. Tout usage de la plateforme
      Speeker par l’utilisateur après la modification des conditions générales
      d’utilisation vaut acceptation par ce dernier des nouvelles conditions
      générales.
    </p>
    <p>
      Les conditions générales figurant en ligne sur la plateforme Speeker
      prévalent sur toute version imprimée de date antérieure.
    </p>

    <h3>Profil utilisateur</h3>
    <h4>Création d’un compte personnel</h4>
    <p>
      L’accès à certains contenus est conditionné à la création d’un profil
      Utilisateur grâce à Facebook, Gmail ou une adresse email.
    </p>
    <p>
      L’inscription et l’accès à la plateforme Speeker sont réservés
      exclusivement aux personnes physiques majeures et capables juridiquement
      et ayant rempli et validé le formulaire d’inscription de la plateforme
      Speeker. L’inscription de l’utilisateur et la création de son compte
      personnel se font au moyen d’un formulaire d’inscription accessible sur la
      plateforme Speeker.
    </p>
    <p>
      La procédure d’inscription via le formulaire en ligne comprend les étapes
      suivantes :
    </p>
    <p>
      l’internaute complète un formulaire d’inscription en remplissant les
      champs nécessaires dont certains identifiés comme tels ont un caractère
      impératif. Les informations doivent être exactes et mises à jour
      régulièrement. Il est strictement interdit de créer un faux profil ;
    </p>
    <p>
      l’internaute prend connaissance et accepte les présentes conditions
      générales en cochant la case prévue à cet effet et prend également
      connaissance et accepte les conditions générales du prestataire de service
      de paiement ; s’il n’accepte pas les présentes conditions générales et/
      celles du prestataire de service de paiement, la création du compte
      personnel n’est pas possible ;
    </p>
    <p>
      une fois le formulaire correctement renseigné, l’internaute valide le
      formulaire et reçoit un courrier électronique de finalisation de
      l’inscription sur l’adresse électronique fournie. Une fois la confirmation
      de l’inscription effectuée, par l’internaute, celui-ci devient Utilisateur
      ; un mail de confirmation de l’inscription et de la création de compte
      personnel est adressé à l’utilisateur.
    </p>
    <p>
      Lors de son inscription, l’Utilisateur s’engage à fournir des informations
      exactes, sincères et à jour sur sa personne et son état civil.
    </p>
    <p>
      L'Utilisateur doit ainsi fournir impérativement une adresse e-mail valide,
      sur laquelle le site lui adressera une confirmation de son inscription à
      ses services.
    </p>
    <p>
      Toute communication réalisée par l’Editeur ou par la plateforme Speeker
      est en conséquence réputée avoir été réceptionnée et lue par
      l'Utilisateur. Ce dernier s'engage donc à consulter régulièrement les
      messages reçus sur cette adresse e-mail et à répondre dans un délai
      raisonnable si cela est nécessaire.
    </p>
    <p>
      L’Editeur se réserve en tout état de cause la possibilité de refuser une
      demande d'inscription aux services en cas de non-respect par l'Utilisateur
      des dispositions des présentes conditions générales.
    </p>

    <h4>Identifiant et mot de passe</h4>
    <p>
      L’Utilisateur garantit l’exactitude des informations fournies pour les
      besoins de son inscription
    </p>
    <p>
      Les mots de passe et identifiants sont personnels, confidentiels et
      incessibles. L’Utilisateur s’engage ainsi à ne jamais le communiquer à des
      tiers. Afin de protéger au maximum la sécurité des comptes utilisateurs de
      la plateforme Speeker, l’Utilisateur doit veiller à ne pas réutiliser le
      même mot de passe que celui associé à d’autres comptes lui permettant
      d’accéder à des services tiers fournis par des sociétés tierces.
    </p>
    <p>
      L’Utilisateur s’engage à signaler à l’Editeur, à l’adresse électronique
      suivante : videom4p@gmail.com et dans les plus brefs délais, toute
      utilisation frauduleuse de son compte personnel ou toute perte, vol ou
      divulgation de ses identifiants et mot de passe.
    </p>
    <p>
      L’identification de l’Utilisateur au moyen de ses identifiants et mot de
      passe vaut imputabilité des opérations effectuées au moyen desdits mot de
      passe et identifiant.
    </p>
    <p>
      L’utilisateur est seul responsable de l’utilisation de la plateforme
      Speeker qui est faite sous son identifiant et mot de passe.
    </p>
    <p>
      L’identifiant et le mot de passe sont modifiables via la plateforme
      Speeker par l’Utilisateur sur la page « Edit my profile ».
    </p>

    <h4>Fermeture du compte personnel</h4>
    <p>
      L’utilisateur peut à tout moment renoncer à utiliser la plateforme Speeker
      et fermer son compte personnel, sans frais et sans motif en envoyant un
      mail à l’adresse suivante : videom4p@gmail.com ou par courrier à : Thomas
      Perron Co – A08, 1247 avenue de Bayonne, 64210 Bidart, France.
    </p>
    <p>
      La désinscription est effective un mois après l’envoi du mail ou du
      courrier
    </p>
    <p>
      L’Editeur conserve pendant une durée raisonnable les contenus utilisateurs
      et les données à caractère personnel de l’utilisateur à des fins notamment
      probatoire et de réactivation du compte.
    </p>
    <p>
      La fermeture du compte personnel par l’utilisateur dans les conditions
      prévues au présent paragraphe entraîne de plein droit la résiliation des
      présentes.
    </p>
    <p>
      Dans tous les cas, l’utilisateur reste responsable de toute utilisation de
      son compte personnel antérieure à la fermeture de ce compte.
    </p>

    <h3>Description de la plateforme Speeker</h3>
    <p>
      La plateforme Speeker permet aux Speekeriens de partager leurs
      expériences, leurs connaissances et leurs points de vue sur des sujets
      spécifiques via des vidéos enregistrées sur la Plateforme.
    </p>
    <p>
      La plateforme Speeker intervient comme un simple intermédiaire technique
      permettant la mise en relation et l’échange de connaissances entre deux
      Speekeriens.
    </p>
    <p>
      Evaluation des videos : <br />
      Les Speekeriens sont invités à évaluer les vidéos des autres speekeriens.
      Ces notations et commentaires libres permettent au créateur de la vidéo de
      recevoir du feedback.
    </p>
    <p>
      Les notations ne sont pas contrôlées par l’Editeur et sont de la seule
      responsabilité des Utilisateurs.
    </p>

    <h3>Obligation de l'éditeur</h3>
    <h4>Qualité des services</h4>
    <p>
      L’Editeur met en œuvre les solutions techniques à sa disposition pour
      permettre l’accès à la plateforme 24 heures sur 24, 7 jours sur 7. Il peut
      néanmoins à tout moment suspendre, limiter, ou interrompre l’accès à la
      plateforme ou à certaines fonctionnalités de celle-ci afin de procéder à
      des mises à jour, des modifications de son contenu ou toute autre action
      jugée nécessaire au bon fonctionnement de la plateforme.
    </p>
    <p>
      L’Editeur s’efforce de fournir un service de qualité. Il permet aux
      Utilisateurs d'utiliser les moyens de communication mis à leur disposition
      dans les meilleures conditions possibles.
    </p>
    <p>
      En raison de la nature et de la complexité du réseau de l’internet, et en
      particulier, de ses performances techniques et des temps de réponse pour
      consulter, interroger ou transférer les données d’informations, l’Editeur
      fait ses meilleurs efforts, conformément aux règles de l’art, pour
      permettre l’accès et l’utilisation de la plateforme Speeker. L’Editeur ne
      saurait, en effet, assurer une accessibilité ou une disponibilité absolue
      de la plateforme Speeker permettant l’accès au service.
    </p>
    <p>
      Par conséquent, l’Editeur ne pourra être tenue responsable en cas
      d’indisponibilité de la plateforme Speeker, pour quelque cause que ce
      soit. De la même façon, l’Editeur ne peut garantir l’intégrité des
      contenus Utilisateurs. Il appartient donc à l’Utilisateur de prendre les
      mesures nécessaires à cet effet, notamment concernant la sauvegarde des
      contenus postées par l’Utilisateur.
    </p>
    <p>
      L’Editeur ne saurait être responsable du bon fonctionnement de
      l’équipement informatique de l’utilisateur ainsi que de son accès à
      internet.
    </p>
    <h4>Maintenance et mise à jour</h4>
    <p>
      L’Editeur fait ses meilleurs efforts pour fournir des services performants
      à l’utilisateur. Il s’engage à mettre en œuvre des moyens adaptés pour
      maintenir les services dans des conditions opérationnelles optimales.
    </p>
    <p>
      L’Editeur se réserve le droit, sans préavis, ni indemnité, de fermer
      temporairement la plateforme Speeker notamment pour effectuer une mise à
      jour, des opérations de maintenance, des modifications ou changements sur
      les méthodes opérationnelles et fonctionnalités sans que cette liste soit
      limitative.
    </p>
    <p>
      L’Editeur n’est pas responsable des dommages de toute nature qui peuvent
      résulter de ces changements et /ou d’une indisponibilité temporaire de la
      plateforme Speeker ou des services qui y sont associés.
    </p>
    <p>
      L’Editeur se réserve le droit de complémenter ou de modifier ou de faire
      modifier, à tout moment, la plateforme Speeker et les services qui y sont
      disponibles en fonction de l’évolution des technologies et en informera
      l’utilisateur par tous moyens.
    </p>
    <h4>Sécurité</h4>
    <p>
      La plateforme Speeker est un système de traitement automatisé de données.
      Tout accès frauduleux à ce dernier est interdit et sanctionné pénalement.
    </p>
    <p>
      L’Editeur fait ses meilleurs efforts, conformément aux règles de l’art,
      pour sécuriser la plateforme Speeker eu égard à la complexité de
      l’internet. Il ne saurait cependant assurer une sécurité absolue.
      L’utilisateur déclare accepter les caractéristiques et limites de
      l’internet. L’utilisateur se doit d’informer l’Editeur de toute
      défaillance de la plateforme Speeker.
    </p>
    <p>
      L’utilisateur a conscience que les données circulant sur l’internet ne
      sont pas nécessairement protégées, notamment contre les détournements
      éventuels. L’utilisateur accepte de prendre toutes les mesures appropriées
      de façon à protéger ses propres données de la contamination par des
      éventuels virus sur le réseau de l’internet.
    </p>

    <h3>Règles de conduite de l'utilisateur</h3>
    <p>
      L’Utilisateur s’engage à n’utiliser la plateforme Speeker qu’à des fins de
      rencontre pour un partage de connaissance et d’expérience entre les
      Utilisateurs.
    </p>
    <p>En outre, l’Utilisateur s’engage :</p>
    <ul>
      <li>
        à n’utiliser le la plateforme Speeker que dans les conditions
        définitions par l’Editeur ;
      </li>
      <li>
        à ne pas détourner l’utilisation de la plateforme Speeker à des fins
        contraires aux bonnes mœurs et aux lois et règlements ;
      </li>
      <li>à ne commettre aucun acte de contrefaçon ;</li>
      <li>à ne pas harceler autrui.</li>
    </ul>
    <p>Il lui est par conséquent formellement interdit de :</p>
    <ul>
      <li>
        tenir des propos à caractère raciste, xénophobe, antisémite, misogyne,
        homophobe, négationniste, pornographique, pédophile, pédopornographique…
        ;
      </li>
      <li>
        tenir des propos injurieux, diffamatoires, ou portant atteinte à la vie
        privée ou à la réputation, et plus généralement aux droits de la
        personnalité de quiconque ;
      </li>
      <li>porter atteinte au droit à l’image des personnes ;</li>
      <li>
        tenir des propos portant atteinte à la dignité humaine ou à la
        réputation commerciale des marques, des produits ou des services des
        fournisseurs ou des prestataires que l’utilisateur cite dans ses
        publications ;
      </li>
      <li>
        tenir des propos incitant à la violence, au suicide, au terrorisme, à
        l’utilisation, la fabrication ou la distribution de substances illicites
        ;
      </li>
      <li>
        tenir des propos incitant aux crimes ou aux délits ou qui en font
        l’apologie et plus particulièrement les crimes contre l’humanité ;
      </li>
      <li>
        tenir des propos portant atteinte aux droits de propriété intellectuelle
        de tiers (notamment textes, photographies) ;
      </li>
      <li>
        tenir des propos incitant à la contrefaçon ou qui en font l’apologie ;
      </li>
      <li>publier intentionnellement du contenu faux, erroné ou trompeur ;</li>
      <li>
        porter atteinte aux droits des autres utilisateurs et/ou aux droits des
        tiers ;
      </li>
      <li>
        publier des contenus comportant des virus, cheval de Troie, « Worms »,
        bombe à retardement, « cancel bots » ou tout autre programme
        informatique visant à endommager ou à intercepter clandestinement tout
        système informatique, données ou informations nominatives.
      </li>
    </ul>
    <p>
      De manière plus générale, l’Utilisateur s’interdit de publier sur la
      plateforme Speeker toute publication qui serait en contradiction avec les
      réglementations en vigueur.
    </p>
    <p>
      L’Utilisateur est responsable de l’utilisation faite par lui de la
      plateforme Speeker. Il s’engage à utiliser l’application de façon loyale,
      dans le respect des présentes conditions générales, des lois et règlements
      applicables, notamment les lois relatives à la propriété intellectuelle et
      industrielle, à l’informatique, aux fichiers, à la vie privée et à
      l’atteinte à la réputation des personnes.
    </p>
    <p>
      L’Utilisateur s’interdit de collecter de quelque manière que ce soit des
      informations sur les autres utilisateurs, manuellement ou de manière
      automatisée, en particulier les adresses de courrier électronique, sans
      leur consentement, notamment en vue de l’envoi de prospections non
      sollicitées, de spams ou de chaînes de courriers électroniques.{" "}
    </p>
    <p>
      L’Utilisateur s’engage à ne pas perturber l’usage que pourrait faire les
      autres Utilisateurs de la plateforme Speeker.
    </p>
    <p>L’Utilisateur s’engage ainsi à ne pas :</p>
    <ul>
      <li>usurper l’identité d’autrui ;</li>
      <li>s’approprier le mot de passe d’un autre Utilisateur ;</li>
      <li>modifier ou détruire des informations ne lui appartenant pas ;</li>
      <li>
        accéder à des informations appartenant à d’autres utilisateurs sans leur
        autorisation ;
      </li>
      <li>
        se connecter ou tenter de se connecter sur un compte sans autorisation ;
      </li>
      <li>
        laisser quelqu’un utiliser son nom d’Utilisateur et/ou son mot de passe.
      </li>
    </ul>
    <p>
      L’Utilisateur s’engage à ne pas créer ou utiliser d’autres comptes que
      celui initialement créé, que ce soit sous sa propre identité ou sur celle
      de tiers, sauf autorisation préalable et écrite de l’Editeur.
    </p>
    <p>
      L’Utilisateur s’engage à ne commettre aucun acte pouvant mettre en cause
      la sécurité informatique de l’Editeur, et notamment de la plateforme
      Speeker, ou des autres Utilisateurs.
    </p>
    <p>
      L’Utilisateur s’engage à ne pas interférer ou interrompre le
      fonctionnement normal de la plateforme Speeker.
    </p>
    <p>
      L’Utilisateur s’engage à indemniser l’Editeur, ses directeurs, ses
      employés et autres agents en cas de plainte, action, poursuite,
      condamnation de ces derniers résultant du non-respect des conditions
      générales par l’Utilisateur.
    </p>
    <p>
      L’Utilisateur s’engage à l’égard de l’Editeur à lui notifier tout
      changement relatif à son adresse électronique et reconnaît qu’à défaut, il
      restera seul responsable des conséquences de quelques natures que ce soit,
      qui pourraient en résulter.
    </p>
    <p>
      En cas de manquement par un Utilisateur à l’une ou l’autre des règles
      précitées, l’Editeur se réserve le droit de lui bloquer l’accès à tout ou
      partie des services de la plateforme Speeker, de façon temporaire ou
      définitive, sans aucune contrepartie et notification à l’Utilisateur.
      L’Utilisateur encourt également la suppression de son compte et de
      l’ensemble des services qui lui sont associés.
    </p>
    <p>
      Il est par ailleurs précisé que l’Editeur, dans le cadre de sa politique
      de modération, se réserve également le droit de retirer tout ou partie des
      contenus, informations et données de toute nature que l’Utilisateur aura
      mis en ligne sur l’application, sans que celui-ci ne puisse s’y opposer.
    </p>

    <h3>Responsabilités</h3>
    <p>L'Editeur n'est responsable que du contenu qu'il a lui-même édité.</p>
    <p>L'Editeur n'est pas responsable :</p>
    <ul>
      <li>
        en cas de problématiques ou défaillances techniques, informatiques ou de
        compatibilité de la plateforme Speeker avec un matériel ou logiciel quel
        qu'il soit ;
      </li>
      <li>
        des dommages directs ou indirects, matériels ou immatériels,
        imprévisibles résultant de l'utilisation ou des difficultés
        d'utilisation du site ou de ses services ;
      </li>
      <li>
        des caractéristiques intrinsèques de l'Internet, notamment celles
        relatives au manque de fiabilité et au défaut de sécurisation des
        informations y circulant ;
      </li>
      <li>
        des contenus ou activités illicites utilisant sa plateforme et ce, sans
        qu'il en ait pris dûment connaissance au sens de la Loi n°2004575 du 21
        juin 2004 pour la confiance dans l'économie numérique et la Loi
        n°2004-801 du 6 août 2004 relative à la protection des personnes
        physiques à l'égard de traitement de données à caractère personnel.
      </li>
    </ul>
    <p>L'Utilisateur est responsable :</p>
    <ul>
      <li>de la protection de son matériel et de ses données ;</li>
      <li>
        de l'utilisation qu'il fait de la plateforme Speeker ou de ses services
        ;
      </li>
      <li>du respect des présentes conditions générales.</li>
    </ul>
    <p>
      L’Utilisateur utilise les services mis à disposition par l’Editeur à ses
      risques et périls. L’Editeur ne peut en aucun cas garantir que les
      services proposés ne subiront aucune interruption. Du fait de la nature
      même du réseau internet, l’obligation de mise à disposition des contenus
      se limite à une obligation de moyen.
    </p>
    <p>
      De la même façon, les informations que l’Utilisateur obtient dans le cadre
      des services proposés par l’Editeur, sous quelque forme que ce soit, ne
      donnent droit à aucune garantie.
    </p>
    <p>
      Toutes les informations et données diffusées dans les contenus édités par
      l’Editeur sont fournies à titre d'information. La fourniture de ces
      données ne saurait être assimilée, de quelque façon que ce soit, à un
      conseil spécifique ou à une aide à la décision aux fins d'effectuer
      notamment une transaction. L’Editeur ne saurait être tenu pour responsable
      d'un quelconque dommage, direct ou indirect, pouvant résulter d'erreurs,
      d'omissions ou de retards dans la transmission desdites informations.{" "}
    </p>

    <h3>Médiation</h3>
    <p>
      Pour toute information, question ou conseil concernant le service proposé
      par l’Editeur, le service clientèle de l’Editeur peut être contacté.
    </p>
    <a href="mailto:videom4p@gmail.com" target="_blank" rel="noopener noreferrer">videom4p@gmail.com</a>

    <h3>Liens hypertextes</h3>
    <p>
      La plateforme Speeker peut contenir des liens hypertextes pointant vers
      d'autres sites internet sur lesquels l’Editeur n'exerce pas de contrôle.
      Malgré les vérifications préalables et régulières réalisés par l'Editeur,
      celui-ci décline tout responsabilité quant aux contenus qu'il est possible
      de trouver sur ces sites.
    </p>
    <p>
      L’Editeur se réserve le droit de faire supprimer à tout moment un lien
      hypertexte pointant vers la plateforme Speeker, s’il l'estime non conforme
      à sa politique éditoriale.
    </p>

    <h3>Données personnelles</h3>
    <p>
      Les traitements de données à caractère personnel mis en œuvre par
      l’Editeur ont été déclarés à la Commission Nationale Informatique et
      Libertés (CNIL).
    </p>
    <p>
      Les informations collectées ont pour finalité la mise en relation des
      Speekeriens, la gestion des Utilisateurs de la plateforme Speeker, des
      lettres d’informations (newsletter) ou des prospects. Elles sont destinées
      exclusivement à un traitement interne et ne sont en aucun cas cédées à des
      tiers.
    </p>
    <p>
      En vertu des dispositions de la Loi n°78-17 du 6 janvier 1978 relative à
      l'informatique, aux fichiers et aux libertés, l'utilisateur bénéficie,
      notamment, d'un droit d'opposition (articles 32 et 38), d'accès (articles
      38 et 39) et de rectification (article 40) des données le concernant.
    </p>
    <p>
      Pour faire usage de l'un des droits précités, l'utilisateur doit
      s'adresser à l'Editeur en le contactant par e-mail à l'adresse suivante :
      videom4p@gmail.com, ou par courrier recommandé adressé au siège social de
      l'Editeur : Thomas Perron Co SASU, 1247 Avenue de Bayonne, 64210 Bidart
      France, en précisant ses nom, prénom(s), adresse et adresse(s) e-mail et
      en joignant une photocopie d’un titre d’identité valide.
    </p>

    <h3>Cookies</h3>
    <p>
      La plateforme fait éventuellement recours aux techniques de "cookies" lui
      permettant de traiter des statistiques et des informations sur le trafic,
      de faciliter la navigation et d'améliorer le service pour le confort de
      l'utilisateur, lequel peut s'opposer à l'enregistrement de ces "cookies"
      en configurant son logiciel de navigation.
    </p>

    <h3>Confidentialité</h3>
    <p>
      Dans le cadre des présentes, l’ensemble des informations ou données
      communiquées par l’Utilisateur à l’Editeur est confidentiel.
    </p>
    <p>L’Editeur s’engagent naturellement à :</p>
    <ul>
      <li>
        traiter les informations confidentielles avec le même degré de
        protection qu’il accorde à ses propres informations confidentielles de
        même importance ;
      </li>
      <li>
        garder les informations confidentielles et qu’elles ne soient pas
        divulguées ni susceptibles de l’être directement ou indirectement à tout
        tiers{" "}
      </li>
      <li>
        éviter que les informations confidentielles ne soient ni copiées, ni
        reproduites, ni dupliquées, en partie ou en totalité, lorsque de telles
        copies, reproductions ou duplications ne sont pas directement liées à
        l’exécution des présentes.
      </li>
    </ul>
    <p>
      Les parties conviennent expressément de ne porter atteinte en aucune façon
      aux droits de propriété portant sur les informations confidentielles.
    </p>

    <h3>Propriété intellectuelle</h3>
    <p>
      Tous les contenus (textes, images, photographies, infographies,
      diaporamas, vidéos…) mis à disposition sur la plateforme Speeker, toutes
      les marques reproduites sur la plateforme Speeker, tous les programmes
      et/ou technologies fournies en relation avec le site et, plus
      généralement, tout ou partie du site lui-même sont protégés au titre des
      droits de la propriété intellectuelle, et ce pour le monde entier.
    </p>
    <p>
      L’inscription sur la plateforme Speeker n’entraîne le transfert d'aucun de
      ces droits de propriété intellectuelle au profit de l’utilisateur quel
      qu'il soit.
    </p>
    <p>
      En conséquence, l’Utilisateur s'interdit (i) de reproduire et/ou
      d'utiliser les marques et logos présents sur la plateforme Speeker; (ii)
      de copier, modifier, traduire, reproduire, diffuser, vendre, publier,
      exploiter de toute autre manière et diffuser dans un autre format sous
      forme électronique ou autre tout ou partie des contenus (même
      partiellement) présents sur le site ; (iii) de céder un droit quelconque
      sur tout ou partie d’un contenu de la plateforme Speeker à un tiers.
    </p>
    <p>
      La reproduction d'un ou de plusieurs des contenus et services présents sur
      la plateforme Speeker, dans leur intégralité ou non, est soumise à une
      autorisation préalable et expresse de l’Editeur.
    </p>
    <p>
      La violation de ces dispositions impératives est constitutive d’une
      contrefaçon et soumet le contrevenant, et toute personne responsable, aux
      peines pénales et civiles prévues par la loi.
    </p>

    <h3>Divers</h3>
    <p>
      Contact <br />
      Pour toute question ou demande d'information concernant la plateforme
      Speeker, ou tout signalement de contenu ou d'activités illicites,
      l'utilisateur peut contacter l'Editeur à l'adresse e-mail suivante :
      videom4p@gmail.com ou adresser un courrier recommandé avec accusé de
      réception à : Thomas Perron Co SASU, 1247 Avenue de Bayonne, 64210 Bidart,
      France.
    </p>
    <p>
      Bonne foi <br />
      Les parties conviennent d’exécuter leurs obligations avec une parfaite
      bonne foi.
    </p>
    <p>
      Nullité <br />
      Si une ou plusieurs stipulations du présent contrat sont tenues pour non
      valides ou déclarées comme telles en application d’une loi, d’un règlement
      ou à la suite d’une décision passée en force de chose jugée d’une
      juridiction compétente, les autres stipulations garderont toute leur force
      et leur portée.
    </p>
    <p>
      Survivance <br />
      Les clauses déclarées comme survivantes après la fin des présentes
      conditions générales, quelles que soient les modalités de cessation,
      telles qu’arrivées du terme ou rupture contractuelle, continuent à
      s’appliquer jusqu’au terme de leur objet particulier. Il en est ainsi,
      notamment, des clauses de propriété et de confidentialité.
    </p>

    <p>
      LOI APPLICABLE ET JURIDICTION COMPÉTENTE LES PRESENTES CONDITIONS
      GENERALES D'UTILISATION SONT REGIES PAR LA LOI FRANÇAISE. EN CAS DE
      DIFFEREND ET A DEFAUT D'ACCORD AMIABLE, LE LITIGE SERA PORTE DEVANT LES
      TRIBUNAUX DE BAYONNE CONFORMEMENT AUX REGLES DE COMPETENCE EN VIGUEUR.
    </p>

    <h5>
      For more information, please refer to our website:
      <a href="https://www.made4pitch.com" target="_blank" rel="noopener noreferrer">https://www.made4pitch.com</a>
    </h5>
  </div>
);
export default CGU;
